import { Script, WrapPageElementNodeArgs } from 'gatsby'
import React, { ReactElement } from 'react'
import { HistoryLocation } from '@gatsbyjs/reach-router'

const selectMatomoTrackingScript = (siteId: string | undefined): string => {
  switch (siteId) {
    case '1': {
      return '/matomo-loader-prod.js'
    }
    case '3': {
      return '/matomo-loader-stg.js'
    }
    default: {
      return '/matomo-loader-prod.js'
    }
  }
}

type PageHeadProps = WrapPageElementNodeArgs & {
  pageContext: MCDC.Contentful.IPageContext
  location: HistoryLocation
}

export default function PageHead({
  pageContext,
  location,
}: PageHeadProps): ReactElement {
  const { page } = pageContext
  const { metaTags: meta } = page
  return (
    <>
      <>
        {meta?.metaTitle && <title>{meta.metaTitle}</title>}
        {meta?.metaDescription && (
          <meta name="description" content={meta.metaDescription} />
        )}
        {meta?.metaOgTitle && (
          <meta property="og:title" content={meta.metaOgTitle} />
        )}
        <meta name="twitter:card" content="summary" />
        {meta?.metaOgDescription && (
          <meta property="og:description" content={meta.metaOgDescription} />
        )}
        {meta?.metaOgImage && (
          <meta property="og:image" content={meta.metaOgImage} />
        )}
        {meta?.canonical && <link rel="canonical" href={meta.canonical} />}
        {meta?.noIndex && <meta name="robots" content="noindex" />}
        <meta
          key="google-site-verification"
          name="google-site-verification"
          content="3sRL2pcoHiK0JbYhWWFLKiCYii2zNNmFf0F9KcVK140"
        />
        <Script
          key="onetrust-init"
          src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
          type="text/javascript"
          charSet="UTF-8"
          data-domain-script={
            process.env.CONSENT_ONETRUST_ID ||
            `4c3fd151-194f-4c9d-bbfd-8eff97aebef2-test`
          }
          defer
        />
        <Script
          key="chatbot"
          src={'/chatbot-loader.js'}
          type="text/javascript"
          defer
        />
        <Script
          key="cssvars"
          src={'/cssvars-loader.js'}
          type="text/javascript"
          defer
        />
        <Script
          key="matomo"
          src={selectMatomoTrackingScript(process.env.TRACKING_MATOMO_SITE_ID)}
          type="text/javascript"
          defer
        />
        <Script
          key="OnetrustCustomizer"
          src={'/onetrust-customizer.js'}
          type="text/javascript"
          defer
        />
      </>
    </>
  )
}
